import { dayMonth } from './listFormat';

// The wording and small rules of the agent case pages, in one place. Money is shown with its currency CODE ("USD 29,268"), each document in its
// own currency (no conversion). A fact the server does not hold arrives as null and is shown as "—": nothing is made up.

export const DASH = '—';

const nf = (n, min, max) => Number(n).toLocaleString('en-GB', { minimumFractionDigits: min, maximumFractionDigits: max });

// "USD 29,268" (cents only when there are some); a price always has two decimals: "USD 9.95".
export function codeMoney(currency, n, { price = false } = {}) {
  if (n == null || Number.isNaN(Number(n))) return DASH;
  const num = Number(n);
  const body = price ? nf(num, 2, 2) : (Number.isInteger(num) ? nf(num, 0, 0) : nf(num, 2, 2));
  return currency ? `${currency} ${body}` : body;
}

// "+USD 410"
export const plusMoney = (currency, n) => (n == null ? DASH : `+${codeMoney(currency, n)}`);

// a quantity: no unit is stored, so a plain number
export const qty = (n) => (n == null || Number.isNaN(Number(n)) ? DASH : nf(n, 0, 2));

const EN_LONG = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

// "12 August" (a calendar day, never moved by the browser's time zone)
export function longDay(iso, lang) {
  if (!iso || !/^\d{4}-\d{2}-\d{2}/.test(iso)) return null;
  const d = new Date(`${iso.slice(0, 10)}T00:00:00Z`);
  if (Number.isNaN(d.getTime())) return null;
  if (lang !== 'it') return `${d.getUTCDate()} ${EN_LONG[d.getUTCMonth()]}`;
  return new Intl.DateTimeFormat('it-IT', { day: 'numeric', month: 'long', timeZone: 'UTC' }).format(d);
}

export const shortDay = (iso, lang) => dayMonth(iso, lang);

const dayNum = (iso) => Math.round(Date.parse(`${iso.slice(0, 10)}T00:00:00Z`) / 86400000);
export const daysAgo = (day, today) => (day && today ? dayNum(today) - dayNum(day) : null);

// "Mobus Fabrics → Architex International" (the buyer as written on the invoice); just the supplier when there is none
export const caseTitle = (c) => [c.supplier && c.supplier.name, c.buyer].filter(Boolean).join(' → ');

// "sent 3 days ago": Floxir cannot tell whether the supplier replied, so it never says "no reply"
export function sentAgo(t, day, today) {
  const n = daysAgo(day, today);
  if (n == null || n < 0) return null;
  if (n === 0) return t('case.stepText.sentToday');
  return n === 1 ? t('case.stepText.sentOne') : t('case.stepText.sentMany', { n });
}

export const poText = (t, n) => (n ? t('search.po', { n }) : null);
